import styled from 'styled-components';

import { StyledSmallCopy } from '../Text/Copy.styles';

export const StyledContextualInfo = styled(StyledSmallCopy)`
  margin-bottom: ${({ theme: { space } }) => space[16]};
`;
